import { FormControlLabel } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { LanguageContext } from '../../../Contexts/LanguageContext';
import logo from '../../../resources/images/icon.png';
import Form from '../../Home/ContactUs/Form/Form';
import './Navbar.css';

const Navbar = ({ isHome = false }) => {
    const [state, setState] = React.useState({
        checkedA: true,
        checkedB: false,
    });

    const handleChange = (event) => {
        setIsBangla(!isBangla)
    };
    const history = useHistory()
    const [isBangla, setIsBangla] = useContext(LanguageContext)
    return (
        <div className="container navbar-container">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <a className="navbar-brand" href="/"><img src={logo} style={{ width: "70px" }} className="logo" alt="" /></a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <FormControlLabel
                    control={
                        <Switch
                            checked={isBangla}
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                        />
                    }
                    label="বাংলা"
                />
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <a className="nav-link" href="#">{isBangla ? "হোম" : "Home"}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/products">{isBangla ? "পণ্যগুলো" : "Products"}</a>
                        </li>
                        {/* <li className="nav-item">
                            <a className="nav-link" href="/articles">{isBangla ? "নিবন্ধ" : "Articles"}</a>
                        </li> */}
                        <li className="nav-item">
                            <a className="nav-link" href="/career">{isBangla ? "কর্মজীবন" : "Career"}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/about">{isBangla ? "আমাদের সম্পর্কে" : "About"}</a>
                        </li>
                        <li className="nav-item">
                            <a className="contact-btn" data-toggle="modal" data-target="#contactModal">{isBangla ? "যোগাযোগ করুন" : "Contact"}</a>
                        </li>
                        <div class="modal fade" id="contactModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">{isBangla ? "যোগাযোগ করুন" : "Contact"}</h5>
                                        <a type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </a>
                                    </div>
                                    <div class="modal-body">
                                        <Form />
                                    </div>
                                    <div class="modal-footer">
                                        <a type="button" class="modal-dismiss-btn" data-dismiss="modal">{isBangla ? "কাটুন" : "Close"}</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ul>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;